import { render, staticRenderFns } from "./ExpiryTab.vue?vue&type=template&id=f32741da"
import script from "./ExpiryTab.vue?vue&type=script&lang=js"
export * from "./ExpiryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports